export default "__VITE_ASSET__2f615134__"